import { Button, Divider, Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useStyles } from "./style";
import KeyboardArrowRightOutlinedIcon from "@material-ui/icons/KeyboardArrowRightOutlined";
import KeyboardArrowLeftOutlinedIcon from "@material-ui/icons/KeyboardArrowLeftOutlined";
import TextEditor from "../../QuillTextEditor/TextEditor";
import { Spinner } from "react-bootstrap";
import InfoIcon from "@mui/icons-material/Info";
import { TextField } from "@mui/material";
import ScorePopup from "./ScorePopup";
import { getRole } from "../../../Core/utils/auth";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import alert_circle from "../../../assets/images/alert_circle.svg";
import MathKeyboard from "../../../SharedComponents/VirtualMathKeyboard/MathKeyboard";

import ZoomOutMapOutlinedIcon from "@mui/icons-material/ZoomOutMapOutlined";

const Questions = ({
  data,
  handleNextSection,
  handleAnswers,
  setHasAnswered,
  questionSetIndex,
  handlePreviousQuestionSet,
  nextSection,
  viewResults,
  nextLoader,
  isExerciseCompleted,
  handleOpenEnded,
  handleSubmitScore,
  handlePopupVisibility,
  score,
  setScore,
  showScoreLoader,
  showSubmitScorePopup,
  previewDialogRef,
}) => {
  const classes = useStyles();
  const [answers, setAnswers] = useState([]);
  const role = getRole();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [displayZoomedImg, setDisplayZoomedImg] = useState(false);

  useEffect(() => {
    if (
      data?.questionType &&
      (data?.questionType === "Open-ended" || data?.questionType === "Text")
    ) {
      if (Object.keys(data?.response)?.length > 0) {
        let value = [data?.response["answer"]];
        setHasAnswered(true);
        setAnswers(value);
        handleAnswers(data?.questionType, data.questionId, value);
      }
    } else {
      const respondedOptions = data?.answers
        .filter((option) => option.responded)
        .map((option) => option.answerId);
      if (respondedOptions && respondedOptions?.length > 0) {
        setHasAnswered(true);
        setAnswers(respondedOptions);
        handleAnswers(data?.questionType, data.questionId, respondedOptions);
      }
    }
  }, []);

  useEffect(() => {
    if (
      data?.questionType === "Question Set" &&
      questionSetIndex !== null &&
      questionSetIndex !== undefined
    ) {
      if (
        data?.subQuestions[questionSetIndex]?.questionType === "Open-ended" ||
        data?.subQuestions[questionSetIndex]?.questionType === "Text"
      ) {
        if (
          Object.keys(data?.subQuestions[questionSetIndex]?.response)?.length >
          0
        ) {
          let value = [
            data?.subQuestions[questionSetIndex]?.response["answer"],
          ];
          setHasAnswered(true);
          setAnswers(value);
          handleAnswers(
            data?.subQuestions[questionSetIndex].questionType,
            data?.subQuestions[questionSetIndex]?.questionId,
            value
          );
        }
      } else {
        const respondedOptions = data?.subQuestions[questionSetIndex]?.answers
          .filter((option) => option.responded)
          .map((option) => option.answerId);
        if (respondedOptions && respondedOptions?.length > 0) {
          setHasAnswered(true);
          setAnswers(respondedOptions);
          handleAnswers(
            data?.subQuestions[questionSetIndex]?.questionType,
            data?.subQuestions[questionSetIndex]?.questionId,
            respondedOptions
          );
        }
      }
    }
  }, [questionSetIndex]);

  const handleNext = (action) => {
    handleNextSection(action);
  };

  const handlePrevious = () => {
    handlePreviousQuestionSet();
  };

  const handleScoreChange = (e, maxScore) => {
    const val = e.target.value;
    const num = parseInt(val);
    const isNumeric = /^[0-9]*$/.test(num);

    if (
      val === "" ||
      (isNumeric && !isNaN(num) && num >= 1 && num <= maxScore)
    ) {
      setScore(val);
    }
  };

  const handleAnswer = (e, questionType, questionId, answerId) => {
    setAnswers((prevSelected) => {
      let ans;
      if (questionType === "Multi Select") {
        ans = prevSelected.includes(answerId)
          ? prevSelected.filter((id) => id !== answerId)
          : [...prevSelected, answerId];
      } else if (questionType === "Single Select") {
        ans = [answerId];
      } else if (questionType === "Open-ended") {
        ans = [e];
      } else if (questionType === "Text") {
        ans = [e.target.value];
      }

      handleAnswers(questionType, questionId, ans);
      setHasAnswered(true);
      return ans;
    });
  };

  const getBorderColor = (item, qType) => {
    if (viewResults) {
      if (item.responded) {
        return item?.correct ? "#70C29C" : "#EB9284";
      } else {
        if (qType === "Single Select") {
          return item?.answerCorrect ? "#70C29C" : "#D9DDE8";
        } else {
          return item?.answerCorrect ? "#FFAE52" : "#D9DDE8";
        }
      }
    } else {
      return answers.includes(item?.answerId) ? " #B6C2CD" : "#D9DDE8";
    }
  };

  const getColor = (item, qType) => {
    if (viewResults) {
      if (item.responded) {
        return item?.correct ? "#7EC8A6" : "#EEA195";
      } else {
        if (qType === "Single Select") {
          return item?.correct ? "#7EC8A6" : "#ffffff";
        } else {
          return item?.correct ? "#FFBC70" : "#ffffff";
        }
      }
    } else {
      return answers.includes(item?.answerId) ? "#C9D2DA" : "#ffffff";
    }
  };

  const getTextAnsColor = (score, scored) => {
    if (viewResults) {
      return score === scored ? "#7EC8A6" : "#EEA195";
    }
  };

  const getTextAnsBorderColor = (score, scored) => {
    if (viewResults) {
      return score === scored ? "#70C29C" : "#EB9284";
    }
  };

  const getSingleSelectMcq = (questionData) => {
    handleOpenEnded(false);
    return (
      <Grid
        className={
          questionData?.questionType !== "Question Set" &&
          `${classes.flex_row} ${classes.justifyCenter}`
        }
      >
        <Grid className={classes.width100}>
          <Typography
            className={`${classes.questionText} ${classes.font14} ${classes.font800} ${classes.headingClr} mt-3`}
          >
            {questionData?.questionText}
          </Typography>
          <DisplayQuestionImg
            setDisplayZoomedImg={setDisplayZoomedImg}
            questionData={questionData}
          />

          <Grid className={`${classes.width100} mt-3`}>
            {questionData?.answers?.map((options, index) => {
              return (
                <Button
                  key={options?.answerId}
                  className={`${classes.optionsBox} ${classes.flex_row} ${classes.justifyLeft} ${classes.alignItemsCenter} ${classes.headingClr} mt-2`}
                  style={{
                    background: getColor(options, questionData?.questionType),
                    border: `1px solid ${getBorderColor(
                      options,
                      questionData?.questionType
                    )}`,
                  }}
                  onClick={(e) =>
                    handleAnswer(
                      e,
                      questionData.questionType,
                      questionData.questionId,
                      options.answerId,
                      options?.responded
                    )
                  }
                >
                  <Grid
                    className={`${classes.optionNoBox} ${classes.flex_col} ${classes.alignItemsCenter} ${classes.headingClr}`}
                  >
                    {options.index}
                  </Grid>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",

                      marginLeft: "12px",
                    }}
                  >
                    {!options.hasImage && (
                      <Grid className={`${classes.optionText}`}>
                        {options.text}
                      </Grid>
                    )}
                    {options.hasImage && (
                      <Grid className={`${classes.optionText}`}>
                        <img
                          src={`${process.env.REACT_APP_ADMIN_PREVIEW_URL}answerImage/${options.answerId}`}
                          alt={`Option ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "160px",
                            display: "block",
                            objectFit: "contain",
                            marginTop: "16px",
                          }}
                        />
                      </Grid>
                    )}
                  </div>
                </Button>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const getQuetionSet = (questionData) => {
    return (
      <Grid>
        <Grid className={classes.questionSummaryContainer}>
          <Grid
            className={`${classes.qNoBox} ${classes.flex_row} ${classes.alignItemsCenter}`}
          >
            Question {questionSetIndex + 1} of {data?.subQuestions?.length}{" "}
          </Grid>
          <DisplayQuestionImg
            setDisplayZoomedImg={setDisplayZoomedImg}
            questionData={questionData}
          />
          {viewResults ? (
            questionData?.review === "pending" ||
            (questionData?.subQuestions[questionSetIndex]?.review ===
              "pending" &&
              role !== "admin") ? (
              <Grid className={classes.insightsScores}>In Review</Grid>
            ) : (
              <Grid className={classes.insightsScores}>
                Score :{" "}
                <span
                  className={classes.actualScore}
                >{`${questionData?.subQuestions[questionSetIndex].scored} / ${questionData?.subQuestions[questionSetIndex].score}`}</span>
              </Grid>
            )
          ) : null}
        </Grid>
        {questionData?.subQuestions[questionSetIndex]?.questionType ===
        "Single Select" ? (
          <Grid>
            {getSingleSelectMcq(questionData?.subQuestions[questionSetIndex])}
          </Grid>
        ) : questionData?.subQuestions[questionSetIndex]?.questionType ===
          "Text" ? (
          <Grid>
            {getTextAnswersQues(questionData?.subQuestions[questionSetIndex])}
          </Grid>
        ) : questionData?.subQuestions[questionSetIndex]?.questionType ===
          "Open-ended" ? (
          <Grid>
            {getOpenEndedQues(questionData?.subQuestions[questionSetIndex])}
          </Grid>
        ) : (
          <Grid>
            {getMultiSelectQuetions(
              questionData?.subQuestions[questionSetIndex]
            )}
          </Grid>
        )}
      </Grid>
    );
  };
  const getOpenEndedQues = (questionData) => {
    handleOpenEnded(false);
    return (
      <Grid
        className={
          data?.questionType !== "Question Set" &&
          `${classes.flex_row} ${classes.justifyCenter}`
        }
      >
        <Grid>
          <Typography
            className={`${classes.questionText} ${classes.font14} ${classes.font800} ${classes.headingClr} mt-3`}
          >
            {questionData?.questionText}
          </Typography>
          <DisplayQuestionImg
            setDisplayZoomedImg={setDisplayZoomedImg}
            questionData={questionData}
          />

          <Grid className={`${classes.quillContainer} mt-3`}>
            <TextEditor
              handleChange={handleAnswer}
              answers={answers[0]}
              questionType={questionData.questionType}
              questionId={questionData.questionId}
              disabled={role === "mentor" || viewResults ? true : false}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  // Text Answers Section
  const getTextAnswersQues = (questionData) => {
    handleOpenEnded(false);
    return (
      <Grid
        className={
          data?.questionType !== "Question Set" &&
          `${classes.flex_row} ${classes.justifyCenter}`
        }
      >
        <Grid className={classes.width100}>
          <Typography
            className={`${classes.questionText} ${classes.font14} ${classes.font800} ${classes.headingClr} mt-3`}
          >
            {questionData?.questionText}
          </Typography>
          <DisplayQuestionImg
            setDisplayZoomedImg={setDisplayZoomedImg}
            questionData={questionData}
          />

          <Grid className={` mt-3`}>
            {questionData?.answerJson?.[0]?.haskeyboard === 1 ? (
              <MathKeyboard
                value={
                  Array.isArray(answers?.[0]) ? answers?.[0]?.[0] : answers?.[0]
                }
                onClick={() => {
                  document.body.style.setProperty(
                    "overflow",
                    "auto",
                    "important"
                  );
                  previewDialogRef?.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                  previewDialogRef?.current?.style.setProperty(
                    "position",
                    "absolute"
                  );
                }}
                onBlur={() => {
                  document.body.style.setProperty("overflow", "hidden");
                  previewDialogRef?.current?.style.setProperty(
                    "position",
                    "fixed"
                  );
                }}
                onChange={(value) => {
                  setAnswers([value]);
                  handleAnswers(
                    questionData.questionType,
                    questionData.questionId,
                    [value]
                  );
                  setHasAnswered(true);
                }}
                readonly={role === "mentor" || viewResults ? true : false}
                placeholder={"\\text{Enter formula}"}
                options={{
                  style: {
                    height: "100%",
                    width: "100%",
                    outline: "none",
                    padding: "4px 12px",
                    display: "flex",
                    color: "var(--clr-text-200)",
                    background: getTextAnsColor(
                      questionData?.score,
                      questionData?.scored
                    ),
                    border: `1px solid ${getTextAnsBorderColor(
                      questionData?.score,
                      questionData?.scored
                    )}`,
                  },
                }}
              />
            ) : (
              <TextField
                name="text-answers"
                placeholder={"Enter your answer"}
                onChange={(e) =>
                  handleAnswer(
                    e,
                    questionData.questionType,
                    questionData.questionId
                  )
                }
                value={answers}
                disabled={viewResults}
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    marginTop: "8px",
                    width: "100%",
                  },
                  "& .MuiInputLabel-root": {
                    color: "#8FBCBC",
                    "&.Mui-focused": {
                      color: "#1976d2",
                    },
                  },
                  "& input": {
                    color: "var(--clr-text-200)",
                    fontFamily: "var(--ff-secondary)",
                    fontSize: "var(--fs-stat-title)",
                    padding: "12px",
                    background: getTextAnsColor(
                      questionData?.score,
                      questionData?.scored
                    ),
                    border: `1px solid ${getTextAnsBorderColor(
                      questionData?.score,
                      questionData?.scored
                    )}`,
                    borderRadius: "8px",
                  },

                  "& .Mui-disabled": {
                    color: "var(--clr-text-200)",
                    WebkitTextFillColor: "var(--clr-text-200)",
                  },
                  "& input::placeholder": {
                    color: "var(--clr-text-1100)",
                    fontFamily: "var(--ff-secondary)",
                    fontSize: "var(--fs-stat-title)",
                  },
                }}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const getMultiSelectQuetions = (questionData) => {
    handleOpenEnded(false);
    return (
      <Grid
        className={
          questionData?.questionType !== "Question Set" &&
          `${classes.flex_row} ${classes.justifyCenter} mt-3`
        }
      >
        <Grid className={classes.width100}>
          <Typography
            className={`${classes.questionText} ${classes.font800} ${classes.headingClr}`}
          >
            {questionData?.questionText}
          </Typography>
          <DisplayQuestionImg
            setDisplayZoomedImg={setDisplayZoomedImg}
            questionData={questionData}
          />

          {!isExerciseCompleted && (
            <Grid className={classes.questionHighlightContainer}>
              <InfoIcon className={classes.infoIcon} />
              <div className={classes.infoText}>
                You can choose more than one option
              </div>
            </Grid>
          )}
          <Grid className={`${classes.width100} mt-3`}>
            {questionData?.answers?.map((options, index) => {
              return (
                <Button
                  className={`${classes.optionsBox} ${classes.flex_row} ${classes.justifyLeft} ${classes.alignItemsCenter} ${classes.headingClr}`}
                  style={{
                    background: getColor(options, questionData?.questionType),
                    border: `1px solid ${getBorderColor(
                      options,
                      questionData?.questionType
                    )}`,
                  }}
                  key={index}
                  onClick={(e) =>
                    handleAnswer(
                      e,
                      questionData.questionType,
                      questionData.questionId,
                      options.answerId,
                      options?.responded
                    )
                  }
                >
                  <Grid
                    className={`${classes.optionNoBox} ${classes.flex_col} ${classes.alignItemsCenter} ${classes.headingClr}`}
                  >
                    {options.index}
                  </Grid>
                  <div style={{ marginLeft: "12px" }}>
                    {!options.hasImage && (
                      <Grid className={`${classes.optionText}`}>
                        {options.text}
                      </Grid>
                    )}
                    {options.hasImage && (
                      <Grid className={`${classes.optionText}`}>
                        <img
                          src={`${process.env.REACT_APP_ADMIN_PREVIEW_URL}answerImage/${options.answerId}`}
                          alt={`Option ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "160px",
                            display: "block",
                            objectFit: "contain",
                            marginTop: "16px",
                          }}
                        />
                      </Grid>
                    )}
                  </div>
                </Button>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const showButton = (key) => {
    if (key === "next") {
      if (
        nextSection ||
        (data?.subQuestions?.length > 0 &&
          questionSetIndex < data?.subQuestions?.length - 1)
      ) {
        return true;
      }
      return false;
    } else if (key === "finish") {
      if (
        !nextSection &&
        data?.subQuestions?.length > 0 &&
        questionSetIndex === data?.subQuestions?.length - 1
      ) {
        return true;
      }
      return false;
    }
  };

  return (
    <>
      <ScorePopup
        showSubmitScorePopup={showSubmitScorePopup}
        handleSubmitScore={handleSubmitScore}
        handlePopupVisibility={handlePopupVisibility}
        handleScoreChange={handleScoreChange}
        score={score}
        showScoreLoader={showScoreLoader}
        maxScore={data?.subQuestions?.[questionSetIndex]?.score || data?.score}
      />
      <Grid
        className={`${classes.InstructionsAndQuestionBox} ${
          data.questionType === "Question Set" ? classes.questionSetBox : ""
        }`}
      >
        <Grid>
          {data.questionType === "Single Select" ? (
            <Grid>{getSingleSelectMcq(data)}</Grid>
          ) : data.questionType === "Text" ? (
            <Grid>{getTextAnswersQues(data)}</Grid>
          ) : data.questionType === "Question Set" ? (
            <Grid>{getQuetionSet(data)}</Grid>
          ) : data.questionType === "Open-ended" ? (
            <Grid>{getOpenEndedQues(data)}</Grid>
          ) : (
            <Grid>{getMultiSelectQuetions(data)}</Grid>
          )}
        </Grid>
        <Divider className="mt-4 mb-1" />
        {(data?.questionType === "Multi Select" ||
          (data?.questionType === "Question Set" &&
            data?.subQuestions[questionSetIndex]?.questionType ===
              "Multi Select")) &&
          viewResults && (
            <Grid className={classes.colorTipContainer}>
              <Grid className={classes.colorTile} />
              <Grid>Correct answer (not selected).</Grid>
            </Grid>
          )}
        {data?.questionType === "Question Set" && (
          <div
            className={
              isMobile ? classes.btnWrapperMobileView : classes.btnWrapper
            }
          >
            {isMobile
              ? role === "mentor" &&
                data?.subQuestions?.[questionSetIndex]?.questionType ===
                  "Open-ended" &&
                (!parseInt(score) || true ? (
                  <Button
                    onClick={() => handlePopupVisibility("open")}
                    className={`${classes.prevQuestionBtn} ${classes.width172pxmobile} ${classes.font14} ${classes.font500}`}
                    disabled={nextLoader}
                  >
                    {data?.subQuestions?.[questionSetIndex]?.review ===
                    "pending" ? (
                      <>
                        <img
                          src={alert_circle}
                          alt="alert"
                          style={{
                            height: "15px",
                            width: "15px",
                            marginRight: "6px",
                          }}
                        />
                        <span>Submit Score</span>
                      </>
                    ) : (
                      "Change Score"
                    )}
                  </Button>
                ) : (
                  <div className={classes.scoreDetailBox}>
                    Score: {parseInt(score)}/
                    {data?.subQuestions?.[questionSetIndex]?.score}
                  </div>
                ))
              : null}
            <Grid
              className={`${classes.navButtonsContainer} ${
                role === "mentor" &&
                data?.subQuestions?.[questionSetIndex]?.questionType ===
                  "Open-ended" &&
                !isMobile
                  ? classes.justifyBetween
                  : isMobile && questionSetIndex === 0
                  ? classes.justifyCenter
                  : questionSetIndex > 0
                  ? classes.justifyBetween
                  : classes.justifyCenter
              }`}
            >
              {questionSetIndex > 0 && (
                <Button
                  onClick={handlePrevious}
                  className={`${classes.prevQuestionBtn} ${classes.font14} ${classes.font500}`}
                  disabled={nextLoader}
                >
                  <KeyboardArrowLeftOutlinedIcon
                    fontSize="small"
                    className="mr-1"
                  />{" "}
                  Back
                </Button>
              )}

              {!isMobile
                ? role === "mentor" &&
                  data?.subQuestions?.[questionSetIndex]?.questionType ===
                    "Open-ended" &&
                  (!parseInt(score) || true ? (
                    <Button
                      onClick={() => handlePopupVisibility("open")}
                      className={`${classes.prevQuestionBtn} ${classes.font14} ${classes.font500}`}
                      disabled={nextLoader}
                    >
                      {data?.subQuestions?.[questionSetIndex]?.review ===
                      "pending" ? (
                        <>
                          <img
                            src={alert_circle}
                            alt="alert"
                            style={{
                              height: "15px",
                              width: "15px",
                              marginRight: "6px",
                            }}
                          />
                          <span>Submit Score</span>
                        </>
                      ) : (
                        "Change Score"
                      )}
                    </Button>
                  ) : (
                    <div className={classes.scoreDetailBox}>
                      Score: {parseInt(score)}/
                      {data?.subQuestions?.[questionSetIndex]?.score}
                    </div>
                  ))
                : null}

              {showButton("next") && (
                <Button
                  onClick={() => handleNext("next")}
                  className={`${classes.nextQuestionBtn} ${classes.font14} ${classes.font500}`}
                  disabled={nextLoader}
                >
                  {nextLoader ? (
                    <Spinner animation="border" variant="light" size="sm" />
                  ) : (
                    <span>
                      Next{" "}
                      <KeyboardArrowRightOutlinedIcon
                        fontSize="small"
                        className="ml-1"
                      />
                    </span>
                  )}
                </Button>
              )}

              {showButton("finish") && (
                <Button
                  onClick={() => handleNext("finish")}
                  className={`${classes.actionNextBtn} ${classes.height38px} ${classes.width128pxmobile}`}
                  disabled={nextLoader}
                >
                  Finish{" "}
                  <KeyboardArrowRightOutlinedIcon
                    fontSize="small"
                    className="ml-1"
                  />
                </Button>
              )}
            </Grid>
          </div>
        )}
      </Grid>
      {displayZoomedImg && (
        <div
          className={classes.zoomedImgContainer}
          onClick={() => setDisplayZoomedImg(false)}
        >
          <img
            src={`https://user-assets.codeyoung.com/question/${
              data?.subQuestions?.length > 0
                ? data?.subQuestions?.[questionSetIndex]?.questionId
                : data?.questionId
            }`}
            alt="Question"
            className={classes.zoomedImg}
          />
        </div>
      )}
    </>
  );
};

export default Questions;

const DisplayQuestionImg = ({ questionData, setDisplayZoomedImg }) => {
  if (questionData?.questionHasImage === 1) {
    return (
      <div
        style={{
          width: "100%",
          height: "200px",
          marginTop: "16px",
          position: "relative",
        }}
      >
        <img
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            padding: "2px",
          }}
          src={`https://user-assets.codeyoung.com/question/${questionData?.questionId}`}
          alt="question"
        />
        <span onClick={() => setDisplayZoomedImg(true)}>
          <ZoomOutMapOutlinedIcon
            style={{
              position: "absolute",
              right: "10px",
              bottom: "10px",
              color: "#fff",
              backgroundColor: "#000",
              borderRadius: "50%",
              padding: "4px",
            }}
          />
        </span>
      </div>
    );
  }

  return null;
};
